"use strict";

require("core-js/modules/es.symbol.description.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.simpleEqualValues = exports.isSomeComponentTypeKey = exports.isComponentTypeKey = exports.getStructureByDependencies = exports.getStatusColor = exports.checkDisabledHighlight = exports.checkDisabledColor = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.array.reverse.js");
var _paulCorePackage = require("paul-core-package");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("./constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  LinkTo,
  ComponentTypes,
  colors
} = _paulCorePackage.constants;
const checkDisabledHighlight = (isDisabled, value) => isDisabled ? _constants.pipesTypes.disabled : value;
exports.checkDisabledHighlight = checkDisabledHighlight;
checkDisabledHighlight.propTypes = {
  isDisabled: _propTypes.default.bool,
  value: _propTypes.default.oneOf(Object.values(_constants.pipesTypes))
};
const checkDisabledColor = (isDisabled, value) => isDisabled ? _constants.pipesColor.disabled : value;
exports.checkDisabledColor = checkDisabledColor;
checkDisabledColor.propTypes = {
  isDisabled: _propTypes.default.bool,
  value: _propTypes.default.oneOf(Object.values(_constants.pipesColor))
};
const concatWithoutDuplication = function concatWithoutDuplication() {
  let list1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let list2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!list1.length) return list2 || [];
  if (!list2.length) return list1 || [];
  return [...new Set(list1.concat(list2))];
};
const calcSizeModal = _ref => {
  let {
    mostCountHtgPipe,
    mostCountHx,
    mostCountPwhSupplyInRow
  } = _ref;
  return _objectSpread(_objectSpread({}, _constants.ModelWidth), {}, {
    [ComponentTypes.HtgHx]: (_constants.ModelWidth[_constants.TypesByDep.HtgHx] + _constants.spaseBetweenModels) * mostCountHx - _constants.spaseBetweenModels,
    [ComponentTypes.HtgPipe]: (_constants.ModelWidth[_constants.TypesByDep.HtgPipe] + _constants.spaseBetweenModels) * (mostCountHtgPipe || 1) - _constants.spaseBetweenModels,
    [ComponentTypes.PwhSupply]: (_constants.ModelWidth[_constants.TypesByDep.PwhSupply] + _constants.spaseBetweenModels) * mostCountPwhSupplyInRow - 2 * _constants.spaseBetweenModels /** @todo why 2 spaseBetweenModels ?? */
  });
};
const calcShowModal = _ref2 => {
  let {
    listPwhSupplies,
    total,
    HtgCc,
    HtgHsFromGeneralTemp,
    HtgHsGeneral,
    HtgHsIdListFromHtgSys,
    HtgSysIdList,
    HtgSubIdList
  } = _ref2;
  return _objectSpread(_objectSpread({}, _constants.defaultShowModel), {}, {
    [_constants.TypesConnect.ConnectFromHtgCcToPwhSupply]: Boolean(listPwhSupplies.length),
    [_constants.TypesByDep.PwhSupply]: Boolean(listPwhSupplies.length),
    [_constants.TypesByDep.PwcPoe]: Boolean(!(listPwhSupplies.length === 0 && Object.keys(total[ComponentTypes.PwhC]).length === 0)),
    [_constants.TypesConnect.ConnectFromPwhSupplyToPwhC]: Boolean(listPwhSupplies.length),
    [_constants.TypesByDep.PwhC]: Boolean(Object.keys(total[ComponentTypes.PwhC]).length),
    [_constants.TypesConnect.ConnectFromPwhCToPwhPipe]: true,
    [_constants.TypesByDep.PwhPipe]: true,
    [_constants.TypesByDep.HtgCc]: Boolean(Object.keys(HtgCc).length),
    [_constants.TypesConnect.ConnectHtgCc]: Boolean(Object.keys(HtgCc).length),
    [_constants.TypesConnect.ConnectFromHtgHxToHtgCc]: Boolean(Object.keys(total[ComponentTypes.HtgHx]).length),
    [_constants.TypesByDep.HtgPipe]: Boolean(Object.keys(total[ComponentTypes.HtgPipe]).length),
    [_constants.TypeByDepDefault.HtgPipe]: Boolean(Object.keys(total[ComponentTypes.HtgHx]).length) /** if there is an htgHx - display */,
    [_constants.TypesConnect.ConnectHtgHsToHtgHx]: Boolean(Object.keys(total[ComponentTypes.HtgHx]).length),
    [_constants.TypesByDep.HtgHx]: Boolean(Object.keys(total[ComponentTypes.HtgHx]).length),
    [_constants.TypesByDep.HtgHsFromGeneral]: Boolean(HtgHsFromGeneralTemp.length),
    [_constants.TypesConnect.ConnectFromHtgHsGeneralToHtgHsFromGeneral]: Boolean(HtgHsFromGeneralTemp.length),
    [_constants.TypesByDep.HtgHsGeneral]: Boolean(HtgHsGeneral.length),
    [_constants.TypesConnect.ConnectFromHtgHsFromHtgSysToHtgHsFromHtgHsGeneral]: Boolean(HtgHsIdListFromHtgSys.length),
    [_constants.TypesByDep.HtgHsFromHtgSys]: Boolean(HtgHsIdListFromHtgSys.length),
    [_constants.TypesConnect.ConnectFromHtgSysToHtgHsFromHtgSys]: Boolean(HtgSysIdList.length) || Boolean(HtgSubIdList.length),
    [_constants.TypesByDep.HtgSys]: Boolean(HtgSysIdList.length),
    [_constants.TypesByDep.HtgSub]: Boolean(HtgSubIdList.length)
  });
};
const calcModelPosition = _ref3 => {
  let {
    showModel,
    sizes
  } = _ref3;
  let positivePositionCalc = _constants.defaultStartModelPosition;
  let negativePositionCalc = _constants.defaultStartModelPosition;
  const positiveStepCalc = function positiveStepCalc() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    positivePositionCalc += _constants.spaseBetweenModels + value;
    return positivePositionCalc;
  };
  // const negativeStepCalc = (value = 0) =>
  //   (negativePositionCalc -= spaseBetweenModels + value) + value;
  const negativeStepCalc = function negativeStepCalc() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    negativePositionCalc -= _constants.spaseBetweenModels + value;
    return negativePositionCalc + value;
  };
  const show = typeByDep => showModel[typeByDep] || showModel["".concat(typeByDep, "Default")];
  const getPositivePositionZ = function getPositivePositionZ() {
    let typeByDep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return show(typeByDep) ? positiveStepCalc(sizes[type || typeByDep]) : 0;
  };
  const getNegativePositionZ = function getNegativePositionZ() {
    let typeByDep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return show(typeByDep) ? negativeStepCalc(sizes[type || typeByDep]) : 0;
  };
  return _objectSpread(_objectSpread({}, _constants.defaultPositions), {}, {
    [_constants.TypesByDep.PwhSupply]: [_constants.defaultPositions[_constants.TypesByDep.PwhSupply][0], _constants.defaultPositions[_constants.TypesByDep.PwhSupply][1], getPositivePositionZ(_constants.TypesByDep.PwhSupply)],
    [_constants.TypesConnect.ConnectFromPwhSupplyToPwhC]: [_constants.defaultPositions[_constants.TypesConnect.ConnectFromPwhSupplyToPwhC][0], _constants.defaultPositions[_constants.TypesConnect.ConnectFromPwhSupplyToPwhC][1], getPositivePositionZ(_constants.TypesConnect.ConnectFromPwhSupplyToPwhC, 'connector')],
    [_constants.TypesByDep.PwcPoe]: [_constants.defaultPositions[_constants.TypesByDep.PwcPoe][0], _constants.defaultPositions[_constants.TypesByDep.PwcPoe][1], getPositivePositionZ(_constants.TypesByDep.PwcPoe) + _constants.spaseBetweenModels],
    [_constants.TypesByDep.PwhC]: [_constants.defaultPositions[_constants.TypesByDep.PwhC][0], _constants.defaultPositions[_constants.TypesByDep.PwhC][1], getPositivePositionZ(_constants.TypesByDep.PwhC)],
    [_constants.TypesByDep.PwhPipe]: [_constants.defaultPositions[_constants.TypesByDep.PwhPipe][0], _constants.defaultPositions[_constants.TypesByDep.PwhPipe][1], getPositivePositionZ(_constants.TypesByDep.PwhPipe)],
    [_constants.TypesConnect.ConnectFromHtgCcToPwhSupply]: [_constants.defaultPositions[_constants.TypesConnect.ConnectFromHtgCcToPwhSupply][0], _constants.defaultPositions[_constants.TypesConnect.ConnectFromHtgCcToPwhSupply][1], getNegativePositionZ(_constants.TypesConnect.ConnectFromHtgCcToPwhSupply, 'connector')],
    [_constants.TypesByDep.HtgCc]: [_constants.defaultPositions[_constants.TypesByDep.HtgCc][0], _constants.defaultPositions[_constants.TypesByDep.HtgCc][1], getNegativePositionZ(_constants.TypesByDep.HtgCc)],
    [_constants.TypesConnect.ConnectHtgCc]: [_constants.defaultPositions[_constants.TypesConnect.ConnectHtgCc][0], _constants.defaultPositions[_constants.TypesConnect.ConnectHtgCc][1], getNegativePositionZ(_constants.TypesConnect.ConnectHtgCc, 'connector')],
    [_constants.TypesConnect.ConnectFromHtgHxToHtgCc]: [_constants.defaultPositions[_constants.TypesConnect.ConnectFromHtgHxToHtgCc][0], _constants.defaultPositions[_constants.TypesConnect.ConnectFromHtgHxToHtgCc][1], getNegativePositionZ(_constants.TypesConnect.ConnectFromHtgHxToHtgCc, 'connector')],
    [_constants.TypesByDep.HtgPipe]: [_constants.defaultPositions[_constants.TypesByDep.HtgPipe][0], _constants.defaultPositions[_constants.TypesByDep.HtgPipe][1], getNegativePositionZ(_constants.TypesByDep.HtgPipe)],
    [_constants.TypesByDep.HtgHx]: [_constants.defaultPositions[_constants.TypesByDep.HtgHx][0], _constants.defaultPositions[_constants.TypesByDep.HtgHx][1], getNegativePositionZ(_constants.TypesByDep.HtgHx)],
    [_constants.TypesConnect.ConnectHtgHsToHtgHx]: [_constants.defaultPositions[_constants.TypesConnect.ConnectHtgHsToHtgHx][0], _constants.defaultPositions[_constants.TypesConnect.ConnectHtgHsToHtgHx][1], getNegativePositionZ(_constants.TypesConnect.ConnectHtgHsToHtgHx, 'connector')],
    [_constants.TypesByDep.HtgHsFromGeneral]: [_constants.defaultPositions[_constants.TypesByDep.HtgHsFromGeneral][0], _constants.defaultPositions[_constants.TypesByDep.HtgHsFromGeneral][1], getNegativePositionZ(_constants.TypesByDep.HtgHsFromGeneral, ComponentTypes.HtgHs)],
    [_constants.TypesConnect.ConnectFromHtgHsGeneralToHtgHsFromGeneral]: [_constants.defaultPositions[_constants.TypesConnect.ConnectFromHtgHsGeneralToHtgHsFromGeneral][0], _constants.defaultPositions[_constants.TypesConnect.ConnectFromHtgHsGeneralToHtgHsFromGeneral][1], getNegativePositionZ(_constants.TypesConnect.ConnectFromHtgHsGeneralToHtgHsFromGeneral, 'connector')],
    [_constants.TypesByDep.HtgHsGeneral]: [_constants.defaultPositions[_constants.TypesByDep.HtgHsGeneral][0], _constants.defaultPositions[_constants.TypesByDep.HtgHsGeneral][1], getNegativePositionZ(_constants.TypesByDep.HtgHsGeneral, ComponentTypes.HtgHs)],
    [_constants.TypesConnect.ConnectFromHtgHsFromHtgSysToHtgHsFromHtgHsGeneral]: [_constants.defaultPositions[_constants.TypesConnect.ConnectFromHtgHsFromHtgSysToHtgHsFromHtgHsGeneral][0], _constants.defaultPositions[_constants.TypesConnect.ConnectFromHtgHsFromHtgSysToHtgHsFromHtgHsGeneral][1], getNegativePositionZ(_constants.TypesConnect.ConnectFromHtgHsFromHtgSysToHtgHsFromHtgHsGeneral, 'connector')],
    [_constants.TypesByDep.HtgHsFromHtgSys]: [_constants.defaultPositions[_constants.TypesByDep.HtgHsFromHtgSys][0], _constants.defaultPositions[_constants.TypesByDep.HtgHsFromHtgSys][1], getNegativePositionZ(_constants.TypesByDep.HtgHsFromHtgSys, ComponentTypes.HtgHs)],
    [_constants.TypesConnect.ConnectFromHtgSysToHtgHsFromHtgSys]: [_constants.defaultPositions[_constants.TypesConnect.ConnectFromHtgSysToHtgHsFromHtgSys][0], _constants.defaultPositions[_constants.TypesConnect.ConnectFromHtgSysToHtgHsFromHtgSys][1], getNegativePositionZ(_constants.TypesConnect.ConnectFromHtgSysToHtgHsFromHtgSys, 'connector')],
    [_constants.TypesByDep.HtgSys]: [_constants.defaultPositions[_constants.TypesByDep.HtgSys][0], _constants.defaultPositions[_constants.TypesByDep.HtgSys][1], getNegativePositionZ(_constants.TypesByDep.HtgSys)],
    [_constants.TypesByDep.HtgSub]: [_constants.defaultPositions[_constants.TypesByDep.HtgSub][0], _constants.defaultPositions[_constants.TypesByDep.HtgSub][1], getNegativePositionZ(_constants.TypesByDep.HtgSub)]
  });
};
const calcHtgHxRelationsPart = _ref4 => {
  let {
    total,
    HtgSysOrSubIdList,
    htgSysOrSubType,
    HtgHsIdListFromHtgSys,
    HtgHsFromGeneral
  } = _ref4;
  /** calculate HtgHx, Hx can have link from HtgHs (after general HtgSys), HtgSys and HtgHs(after HtgSys) */
  const getHtgHxList = _ref5 => {
    let {
      list = [],
      type = ''
    } = _ref5;
    const hxList = list.reduce((accHx, equipmentId, index) => {
      const equipment = total[type][equipmentId];
      const MissingEquipmentOrHtgHxAndHtgCc = !equipment || !equipment[LinkTo.HtgHx].length && !equipment[LinkTo.HtgCc].length;
      if (MissingEquipmentOrHtgHxAndHtgCc) return accHx;
      const AlreadyHasSuchHtgCcIds = accHx.temp[LinkTo.HtgCc].length && equipment[LinkTo.HtgCc].find(ccId => accHx.temp[LinkTo.HtgCc].includes(ccId));
      if (AlreadyHasSuchHtgCcIds) return accHx;
      const AlreadyHasSuchHtgHxIds = accHx.temp[LinkTo.HtgHx].length && equipment[LinkTo.HtgHx].find(hxId => accHx.temp[LinkTo.HtgHx].includes(hxId));
      if (AlreadyHasSuchHtgHxIds) return accHx;
      const getNewTemp = LinkToType => concatWithoutDuplication(accHx.temp[LinkToType], equipment[LinkToType]);
      const getNewResult = () => {
        const newItem = {
          connectWithNext: Boolean(equipment[LinkTo.HtgCc].length),
          id: equipmentId || "".concat(index).concat(type),
          list: equipment[LinkTo.HtgHx].filter(hxId => total[ComponentTypes.HtgHx][hxId])
        };
        return (accHx.result || []).concat([newItem]);
      };
      return {
        temp: {
          [LinkTo.HtgCc]: getNewTemp(LinkTo.HtgCc),
          [LinkTo.HtgHx]: getNewTemp(LinkTo.HtgHx)
        },
        result: getNewResult()
      };
    }, {
      temp: {
        [LinkTo.HtgCc]: [],
        [LinkTo.HtgHx]: []
      },
      result: null
    });
    return hxList.result;
  };
  const htgHxFromSys = getHtgHxList({
    list: HtgSysOrSubIdList,
    type: htgSysOrSubType
  });
  const htgHxFromHs1 = getHtgHxList({
    list: HtgHsIdListFromHtgSys,
    type: ComponentTypes.HtgHs
  });
  const htgHxFromHs3 = getHtgHxList({
    list: HtgHsFromGeneral,
    type: ComponentTypes.HtgHs
  });
  const listOfRelationToHx = [htgHxFromHs1, htgHxFromHs3, htgHxFromSys];
  const ListHtgHx = listOfRelationToHx.reduce((acc, equipments) => {
    if (equipments !== null && equipments !== void 0 && equipments.length) {
      const equipmentsWithoutRepeats = equipments.filter(equipment => !equipment.list.find(listItem => acc.find(item => item.list.includes(listItem))));
      return [...acc, ...equipmentsWithoutRepeats];
    }
    return acc;
  }, []);
  return {
    ListHtgHx
  };
};
const calcHtgPipeRelationsPart = _ref6 => {
  let {
    total,
    activeHtgHx,
    ListHtgHx
  } = _ref6;
  const activeHtgHxData = total[ComponentTypes.HtgHx][activeHtgHx] || null;
  const ListHtgPipe = ListHtgHx.map(hxPositionData => {
    if (!hxPositionData.list.length) {
      return {
        connectWithNext: hxPositionData.connectWithNext,
        list: [],
        hasHx: false,
        id: hxPositionData.id
      };
    }
    return {
      /** @todo connectWithNext need to check from ListHtgHx */
      connectWithNext: hxPositionData.connectWithNext,
      id: activeHtgHx,
      hasHx: true,
      list: (activeHtgHxData === null || activeHtgHxData === void 0 ? void 0 : activeHtgHxData[LinkTo.HtgPipe]) || []
    };
  });
  return {
    ListHtgPipe
  };
};
const calcHtgHsRelationsPart = _ref7 => {
  let {
    total,
    totalHtgSysOrSub,
    HtgSysOrSubIdList,
    htgSysOrSubType
  } = _ref7;
  /**
   * For HtgHs we have 3 positions,
   * we need to know the count of links to this HtgHs to display on the correct position
   */
  const getCountHtgHs = _ref8 => {
    let {
      object = {},
      defAcc = {}
    } = _ref8;
    return Object.values(object).reduce((acc, c) => c[LinkTo.HtgHs].length ? c[LinkTo.HtgHs].reduce((accId, id) => _objectSpread(_objectSpread({}, accId), {}, {
      [id]: (accId[id] || 0) + 1
    }), acc) : acc, defAcc);
  };
  const counterLinkHsInAll = getCountHtgHs({
    object: total[ComponentTypes.HtgHs],
    defAcc: getCountHtgHs({
      object: totalHtgSysOrSub
    })
  });

  /** calculate HtgHs on position after HtgSys */
  /** calculate all HtgHs on this position */
  const tempHs1List = Object.keys(counterLinkHsInAll).reduce((acc, id) => {
    if (counterLinkHsInAll[id] === 1) {
      var _sysItem$LinkTo$HtgCc;
      const sysItem = Object.values(totalHtgSysOrSub).find(sys => sys[LinkTo.HtgHs].includes(id));
      return sysItem && !((_sysItem$LinkTo$HtgCc = sysItem[LinkTo.HtgCc]) !== null && _sysItem$LinkTo$HtgCc !== void 0 && _sysItem$LinkTo$HtgCc.length) ? [...acc, id] : acc;
    }
    return acc;
  }, []);
  /** add empty htgHs by HtgSys without HtgHs on this position */
  const HtgHsIdListFromHtgSys = tempHs1List.length ? HtgSysOrSubIdList.reduce((acc, sysId, index, map) => {
    var _totalHtgSysOrSub$sys, _totalHtgSysOrSub$sys2;
    let different = 0;
    const listFromSysId = sysId ? (_totalHtgSysOrSub$sys = totalHtgSysOrSub[sysId][LinkTo.HtgHs]) === null || _totalHtgSysOrSub$sys === void 0 ? void 0 : _totalHtgSysOrSub$sys.filter(id => tempHs1List.includes(id)) : [];
    if (index === map.length - 1) {
      if (!acc.length && !listFromSysId.length) {
        different = 0;
      } else if (listFromSysId.length) {
        different = map.length - (acc.length + 1);
      } else {
        different = map.length - acc.length;
      }
    }
    if (!sysId) {
      return [...acc, ...(different > 0 ? [...Array(different)] : [])];
    }
    return [...acc, ...(((_totalHtgSysOrSub$sys2 = totalHtgSysOrSub[sysId][LinkTo.HtgHs]) === null || _totalHtgSysOrSub$sys2 === void 0 ? void 0 : _totalHtgSysOrSub$sys2.filter(id => tempHs1List.includes(id))) || []), ...(different > 0 ? [...Array(different)] : [])];
  }, []) : [];

  /** calculate general HtgHs at the position after HtgHs (HtgHs that have a link to other HtgHs) */
  const HtgHsGeneral = Object.keys(counterLinkHsInAll).reduce((acc, id) => {
    var _total$ComponentTypes;
    return counterLinkHsInAll[id] > 1 && (_total$ComponentTypes = total[ComponentTypes.HtgHs][id]) !== null && _total$ComponentTypes !== void 0 && (_total$ComponentTypes = _total$ComponentTypes[LinkTo.HtgHs]) !== null && _total$ComponentTypes !== void 0 && _total$ComponentTypes.length ? [...acc, id] : acc;
  }, []);

  /** calculate all HtgHs at the position after general HtgHs (HtgHs that don't have a link to other HtgHs) */
  const HtgHsFromGeneralTemp = HtgHsGeneral.length ? HtgHsGeneral.reduce((acc, id) => [...acc, ...total[ComponentTypes.HtgHs][id][LinkTo.HtgHs]], []) : Object.keys(counterLinkHsInAll).reduce((acc, id) => {
    var _parentItem$LinkTo$Ht, _total$ComponentTypes2;
    const parentItem = Object.values(totalHtgSysOrSub).find(sys => sys[LinkTo.HtgHs].includes(id)) || tempHs1List.find(tempId => total[ComponentTypes.HtgHs][tempId][LinkTo.HtgHs].includes(id));
    if ((counterLinkHsInAll[id] > 1 || parentItem !== null && parentItem !== void 0 && (_parentItem$LinkTo$Ht = parentItem[LinkTo.HtgCc]) !== null && _parentItem$LinkTo$Ht !== void 0 && _parentItem$LinkTo$Ht.length) && !((_total$ComponentTypes2 = total[ComponentTypes.HtgHs][id]) !== null && _total$ComponentTypes2 !== void 0 && (_total$ComponentTypes2 = _total$ComponentTypes2[LinkTo.HtgHs]) !== null && _total$ComponentTypes2 !== void 0 && _total$ComponentTypes2.length)) {
      return [...acc, id];
    }
    return acc;
  }, []);
  /** calculate empty HtgHs at the position from HtgSys and HtgHs(after HtgSys) */
  const checkComponentsWithLinkToHtgCcForHs3 = _ref9 => {
    let {
      listId = [],
      type = ''
    } = _ref9;
    return listId.reduce((acc, id) => {
      if (total[type][id]) {
        const linksList = total[type][id][LinkTo.HtgCc].length ? total[type][id][LinkTo.HtgCc] : total[type][id][LinkTo.HtgHx] || [];
        const checkRepeats = linksList.length ? Boolean(acc.find(IdFromAcc => {
          const linksListFromAcc = total[type][IdFromAcc][LinkTo.HtgCc].length ? total[type][IdFromAcc][LinkTo.HtgCc] : total[type][IdFromAcc][LinkTo.HtgHx];
          return linksListFromAcc.find(item => linksList.includes(item));
        })) : true;
        return checkRepeats ? acc : [...acc, id];
      }
      return acc;
    }, []);
  };
  const emptyHs3Count = (!HtgHsGeneral.length ? [...checkComponentsWithLinkToHtgCcForHs3({
    listId: HtgHsIdListFromHtgSys,
    type: ComponentTypes.HtgHs
  }), ...checkComponentsWithLinkToHtgCcForHs3({
    listId: HtgSysOrSubIdList,
    type: htgSysOrSubType
  })] : HtgHsGeneral.filter(id => {
    var _total$ComponentTypes3;
    return total[ComponentTypes.HtgHs][id] && ((_total$ComponentTypes3 = total[ComponentTypes.HtgHs][id][LinkTo.HtgCc]) === null || _total$ComponentTypes3 === void 0 ? void 0 : _total$ComponentTypes3.length);
  })).length;
  /** calculate HtgHs on position after general HtgHs */
  const HtgHsFromGeneral = HtgHsFromGeneralTemp.length ? [...Array(emptyHs3Count), ...HtgHsFromGeneralTemp] : []; /** undefined in list - empty htgHs */
  return {
    HtgHsIdListFromHtgSys,
    HtgHsGeneral,
    HtgHsFromGeneral,
    /** @todo export HtgHsFromGeneralTemp ?? */
    HtgHsFromGeneralTemp
  };
};
const calcHtgCcRelationsPart = _ref10 => {
  let {
    total
  } = _ref10;
  /** calculate HtgCc, return object [id]: { information about structure } */
  const HtgCc = Object.values(total[ComponentTypes.HtgCc]).reduce((acc, item) => {
    const tempPwhSupId = item[LinkTo.PwhSupply].find(_id => Object.keys(total[ComponentTypes.PwhSupply]).includes(_id));
    const tempPwhSup = tempPwhSupId ? total[ComponentTypes.PwhSupply][tempPwhSupId] : null;
    return tempPwhSup ? _objectSpread(_objectSpread({}, acc), {}, {
      [item.id]: {
        thingPwhSupplyDeviceType: tempPwhSup === null || tempPwhSup === void 0 ? void 0 : tempPwhSup.thingPwhSupplyDeviceType
      }
    }) : acc;
  }, {});
  return {
    HtgCc
  };
};
const calcHtgSysOrSubRelationsPart = _ref11 => {
  let {
    total
  } = _ref11;
  /**
   * HtgSys list with empty positions when HtgHs > 1
   */
  const HtgSysIdList = Object.values(total[ComponentTypes.HtgSys] || {}).reduce((acc, sys) => [...acc, /** @todo wrong logic [sys.id, ...Array(sys[LinkTo.HtgHs].length - 1)] */
  ...(sys[LinkTo.HtgHs].length > 1 ? [sys.id, ...Array(sys[LinkTo.HtgHs].length - 1)] : [sys.id])], []);
  /**
   * HtgSub list with empty positions when HtgHs > 1
   */
  const HtgSubIdList = Object.values(total[ComponentTypes.HtgSub] || {}).reduce((acc, sys) => [...acc, /** @todo wrong logic [sys.id, ...Array(sys[LinkTo.HtgHs].length - 1)] */
  ...(sys[LinkTo.HtgHs].length > 1 ? [sys.id, ...Array(sys[LinkTo.HtgHs].length - 1)] : [sys.id])], []);
  const isHtgSys = Boolean(HtgSysIdList.length);
  const htgSysOrSubType = isHtgSys ? ComponentTypes.HtgSys : ComponentTypes.HtgSub;
  const totalHtgSysOrSub = total[htgSysOrSubType];
  const HtgSysOrSubIdList = isHtgSys ? HtgSysIdList : HtgSubIdList;
  return {
    totalHtgSysOrSub,
    HtgSysOrSubIdList,
    htgSysOrSubType,
    HtgSysIdList,
    HtgSubIdList
  };
};
const calcPwhSupplyRelationsPart = _ref12 => {
  let {
    total,
    HtgCc
  } = _ref12;
  /** calculate PwhSupplies */
  const pwhSupKeys = Object.keys(total[ComponentTypes.PwhSupply]);
  const pwhSupValues = Object.values(total[ComponentTypes.PwhSupply]);
  const mostCountPwhSupplyInRow = pwhSupValues.find(c => c[LinkTo[ComponentTypes.PwhSupply]].length) ? pwhSupKeys.length : 1;
  const setListPwhSupplies = () => {
    if (mostCountPwhSupplyInRow) {
      if (pwhSupKeys.length > 1 && Object.keys(HtgCc).length > 1) {
        return Object.keys(HtgCc).reduce((acc, ccId) => [...acc, ...total[ComponentTypes.HtgCc][ccId][LinkTo[ComponentTypes.PwhSupply]]], []);
      }
      return pwhSupKeys;
    }
    return pwhSupValues.reduce((acc, _, __, map) => {
      if (acc.length) {
        return [...acc, map.find(c => c[LinkTo[ComponentTypes.PwhSupply]].includes(acc[acc.length - 1])).id];
      }
      return [pwhSupValues.find(item => item[LinkTo[ComponentTypes.PwhC]].length && !item[LinkTo[ComponentTypes.PwhSupply]].length).id];
    }, []).reverse();
  };
  const listPwhSupplies = setListPwhSupplies();
  return {
    listPwhSupplies,
    mostCountPwhSupplyInRow
  };
};
const calcRelationsInStructure = _ref13 => {
  let {
    total,
    activeHtgHx
  } = _ref13;
  const {
    totalHtgSysOrSub,
    HtgSysOrSubIdList,
    htgSysOrSubType,
    HtgSysIdList,
    HtgSubIdList
  } = calcHtgSysOrSubRelationsPart({
    total
  });
  const {
    HtgHsIdListFromHtgSys,
    HtgHsGeneral,
    HtgHsFromGeneral,
    HtgHsFromGeneralTemp
  } = calcHtgHsRelationsPart({
    total,
    totalHtgSysOrSub,
    HtgSysOrSubIdList,
    htgSysOrSubType
  });
  const {
    ListHtgHx
  } = calcHtgHxRelationsPart({
    total,
    HtgSysOrSubIdList,
    htgSysOrSubType,
    HtgHsIdListFromHtgSys,
    HtgHsFromGeneral
  });
  const {
    ListHtgPipe
  } = calcHtgPipeRelationsPart({
    total,
    activeHtgHx,
    ListHtgHx
  });
  const {
    HtgCc
  } = calcHtgCcRelationsPart({
    total
  });
  const {
    listPwhSupplies,
    mostCountPwhSupplyInRow
  } = calcPwhSupplyRelationsPart({
    total,
    HtgCc
  });
  return {
    listPwhSupplies,
    HtgCc,
    HtgHsFromGeneralTemp,
    HtgHsGeneral,
    HtgHsIdListFromHtgSys,
    HtgSysIdList,
    HtgSubIdList,
    ListHtgPipe,
    ListHtgHx,
    mostCountPwhSupplyInRow,
    HtgHsFromGeneral
  };
};
const getStructureByDependencies = _ref14 => {
  let {
    total = {},
    activeHtgHx
  } = _ref14;
  /** relations */
  const {
    listPwhSupplies,
    HtgCc,
    HtgHsFromGeneralTemp,
    HtgHsGeneral,
    HtgHsIdListFromHtgSys,
    HtgSysIdList,
    HtgSubIdList,
    ListHtgPipe,
    ListHtgHx,
    mostCountPwhSupplyInRow,
    HtgHsFromGeneral
  } = calcRelationsInStructure({
    total,
    activeHtgHx
  });
  /** show modal */
  const showModel = calcShowModal({
    listPwhSupplies,
    total,
    HtgCc,
    HtgHsFromGeneralTemp,
    HtgHsGeneral,
    HtgHsIdListFromHtgSys,
    HtgSysIdList,
    HtgSubIdList
  });

  /** sizes */
  const mostCountHtgPipe = ListHtgPipe.reduce((acc, htgPipeList) => {
    var _htgPipeList$list, _htgPipeList$list2;
    return (htgPipeList === null || htgPipeList === void 0 || (_htgPipeList$list = htgPipeList.list) === null || _htgPipeList$list === void 0 ? void 0 : _htgPipeList$list.length) > acc ? htgPipeList === null || htgPipeList === void 0 || (_htgPipeList$list2 = htgPipeList.list) === null || _htgPipeList$list2 === void 0 ? void 0 : _htgPipeList$list2.length : acc;
  }, 1);
  const mostCountHx = ListHtgHx.reduce((acc, hxList) => {
    var _hxList$list, _hxList$list2;
    return (hxList === null || hxList === void 0 || (_hxList$list = hxList.list) === null || _hxList$list === void 0 ? void 0 : _hxList$list.length) > acc ? hxList === null || hxList === void 0 || (_hxList$list2 = hxList.list) === null || _hxList$list2 === void 0 ? void 0 : _hxList$list2.length : acc;
  }, 1);
  const sizes = calcSizeModal({
    mostCountHtgPipe,
    mostCountHx,
    mostCountPwhSupplyInRow
  });

  /** positions */
  const positions = calcModelPosition({
    showModel,
    sizes
  });
  return {
    byDependencies: {
      [_constants.TypesByDep.HtgSys]: HtgSysIdList,
      [_constants.TypesByDep.HtgSub]: HtgSubIdList,
      [_constants.TypesByDep.HtgHsFromHtgSys]: HtgHsIdListFromHtgSys,
      [_constants.TypesByDep.HtgHsGeneral]: HtgHsGeneral,
      [_constants.TypesByDep.HtgHsFromGeneral]: HtgHsFromGeneral,
      [_constants.TypesByDep.HtgHx]: ListHtgHx.map(group => _objectSpread(_objectSpread({}, group), {}, {
        mostCount: mostCountHx
      })),
      [_constants.TypesByDep.HtgPipe]: ListHtgPipe.map(group => _objectSpread(_objectSpread({}, group), {}, {
        mostCount: mostCountHtgPipe
      })),
      [_constants.TypesByDep.HtgCc]: HtgCc,
      [_constants.TypesByDep.PwhSupply]: {
        isSerial: mostCountPwhSupplyInRow > 1,
        idList: listPwhSupplies
      },
      [_constants.TypesByDep.PwcPoe]: total[ComponentTypes.PwcPoe],
      [_constants.TypesByDep.PwhC]: total[ComponentTypes.PwhC],
      [_constants.TypesByDep.PwhPipe]: total[ComponentTypes.PwhPipe]
    },
    sizes,
    positions,
    showModel
  };
};
exports.getStructureByDependencies = getStructureByDependencies;
const isComponentTypeKey = _ref15 => {
  let {
    typeKey,
    key
  } = _ref15;
  return typeof key === 'number' ? Number(typeKey) === key : Boolean(key === null || key === void 0 ? void 0 : key.includes(typeKey));
};
exports.isComponentTypeKey = isComponentTypeKey;
isComponentTypeKey.propTypes = {
  typeKey: _propTypes.default.string,
  key: _propTypes.default.number
};
const isSomeComponentTypeKey = typeKey => keys => {
  if (Array.isArray(keys)) {
    return keys.some(key => isComponentTypeKey({
      typeKey,
      key
    }));
  }
  return isComponentTypeKey({
    typeKey,
    key: keys
  });
};
exports.isSomeComponentTypeKey = isSomeComponentTypeKey;
const simpleEqualValues = (prev, next) => prev === next;
exports.simpleEqualValues = simpleEqualValues;
const getStatusColor = _ref16 => {
  let {
    statusColor
  } = _ref16;
  switch (statusColor) {
    case 'red':
      return colors['main-color-cl-21'];
    case 'blue':
      return colors['main-color-cl-30'];
    default:
      return colors['main-color-cl-15'];
  }
};
exports.getStatusColor = getStatusColor;